export const paths = {
  root: '/',
  storyDetails: '/:id',
};
